import { cn } from '@cocoonspace/ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'

const titleDividerVariants = cva('rounded-full bg-primary', {
	defaultVariants: {
		size: 'default',
	},
	variants: {
		size: {
			default: 'h-2 w-12',
			sm: 'h-1.5 w-8',
		},
	},
})

export const TitleDivider = ({
	className,
	size = 'default',
}: {
	className?: string
} & VariantProps<typeof titleDividerVariants>) => (
	<div className={cn(titleDividerVariants({ size }), className)} />
)
